import i18n from 'i18next'
import { initReactI18next } from "react-i18next";
import detector from 'i18next-browser-languagedetector';
import translationEN from './Locales/en.json'
import translationES from './Locales/es.json'

const resources = {
    en: {
        translation: translationEN
    },
    es: {
        translation: translationES
    }
}

i18n
    .use(detector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "es"        
    });

export default i18n;